import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Autocomplete, Box, Button, Card, CardContent, CardHeader, Container, Divider, Grid, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

import getIdioma from './scripts/Idiomas'
import Empresas from './data/Empresas';
import './App.css';
import Firma from './scripts/Firma';
import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from '@azure/msal-react';
import { PageLayout } from './components/PageLayout';
import { IdTokenData } from './components/DataDisplay';

import './styles/App.css';


const localidades = [
  {
    localidad: "Topaz LATAM"
  },
  {
    localidad: "Topaz Brasil"
  }
];

/**
* msal-react is built on the React context API and all parts of your app that require authentication must be
* wrapped in the MsalProvider component. You will first need to initialize an instance of PublicClientApplication
* then pass this to MsalProvider as a prop. All components underneath MsalProvider will have access to the
* PublicClientApplication instance via context as well as all hooks and components provided by msal-react. For more, visit:
* https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
*/

function Pages() {
  const copyBoxRef = React.createRef();

  const [visualizar, setVisualizar] = useState(false);
  const [assinatura, setAssinatura] = useState(<></>);
  const [valueCombo, setValueCombo] = useState('');
  const [empresa, setEmpresa] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');

  const nomeRef = useRef('');
  const sobreNomeRef = useRef('');
  const cargoRef = useRef('');
  const celularRef = useRef('');
  const codigoRef = useRef('');

  const [errorNome, setErrorNome] = useState(false);
  const [errorSobreNome, setErrorSobreNome] = useState(false);
  const [errorCargo, setErrorCargo] = useState(false);
  const [errorLocalidad, setErrorLocalidad] = useState(false);
  const [errorEmpresa, setErrorEmpresa] = useState(false);

  const [idioma, setIdioma] = useState('esp');
  const [dataIdioma, setDataIdioma] = useState([]);

  const [selection, setSelection] = useState({ start: 0, end: 0 });
  const [keyDown, setKeyDown] = useState(null);

  let pattern = '+598 __ ___ ___';

  useEffect(() => {
    setPhoneNumber(pattern);
  }, [pattern]);

  useEffect(() => {
    let abortController = new AbortController();
    setDataIdioma(getIdioma(idioma));
    return () => {  
      abortController.abort();  
    };
  }, [idioma]);
  useEffect(() => {
    if (valueCombo && Empresas.length === 1) {
      setEmpresa(Empresas[0]);
    }
  }, [valueCombo, Empresas]);

  useLayoutEffect(() => {
    celularRef.current.setSelectionRange(selection.start, selection.end);
  }, [selection.end, selection.start]);

  const handleIdioma = (event, idioma) => { 
    setIdioma(idioma);
  };

  const handleChangeLocation = (ev, value) => {
    if (!value) return;

    const { localidad } = value;

    switch(localidad) {
      case 'Topaz Brasil' :
        pattern = '+55 __ ____-____';
        break;
      default :
        pattern = '+598 __ ___ ___';
        break;
    }
      
    setPhoneNumber(pattern);
    setValueCombo(value);
  }

  const handleChangePhone = (ev) => {
    const { target: { value } } = ev;
    const { key } = keyDown;

    if (key === 'Backspace') {
      setPhoneNumber(value);
      return;
    };

    const clearStr = value.replace(/_/g, '').replace(/-/g, '').replace(/\s/g, '');

    let str = clearStr;
    for(let i = 0; i < 14; i++) {
      if (!str[i]) {
        str += '_';
      }
    }

    let strWithPattern
    switch(valueCombo.localidad) {
      case 'Topaz Brasil' :
        strWithPattern = str.replace(/^([+\d]{3})([0-9_]{2})([0-9_]{5})([0-9_]{4}).*/g, '$1 $2 $3-$4');
        break;
      default :
        strWithPattern = str.replace(/^([+\d]{4})([0-9_]{2})([0-9_]{3})([0-9_]{3}).*/g, '$1 $2 $3 $4');
        break;
    }

    const position = strWithPattern.indexOf('_');

    setSelection({ start: position, end: position });
    setPhoneNumber(strWithPattern);
  }

  const getAssinatura = () => {
    setErrorNome(false);
    setErrorSobreNome(false);
    setErrorCargo(false);
    setErrorLocalidad(false);
    setVisualizar(false);

    if (nomeRef.current.value === '') {
      setErrorNome(true);
    }
    else if (sobreNomeRef.current.value === '') {
      setErrorSobreNome(true);
    }
    else if (cargoRef.current.value === '') {
      setErrorCargo(true);
    }
    else if (!valueCombo) {
      setErrorLocalidad(true);
    }
    else if (!empresa) {
      setErrorEmpresa(true);
    }
    else {
      setAssinatura(
        <Firma
          nome={nomeRef.current.value}
          sobreNome={sobreNomeRef.current.value}
          cargo={cargoRef.current.value.toUpperCase()}
          // endereco={valueCombo.direccion}
          localidad={valueCombo.localidad}
          // link={valueCombo.link}
          codigo={codigoRef.current.value}
          celular={celularRef.current.value}
          empresa={empresa}
          // logo={empresa.logo}
        />
      )
      setVisualizar(true);
    };
  };

  const handleCopiarAssinatura = ev => {
    const copyBoxElement = copyBoxRef.current;
    copyBoxElement.contentEditable = true;
    copyBoxElement.focus();
    document.execCommand('selectAll');
    document.execCommand('copy');
    copyBoxElement.contentEditable = false;
    getSelection().empty();
    alert(dataIdioma.copyConfirm);
  };

  return ( 
    <React.Fragment>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8
        }}
      >
        <Container maxWidth="md">
          <Card sx={{ minWidth: 275 }}>
            <CardHeader
              title={
                <Grid container>
                  <Grid item xs={12} sm={8}>
                    <Typography component="h1" variant="h5" color="primary" gutterBottom>
                      {dataIdioma.title}   
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Box display="flex" justifyContent="flex-end">
                      <ToggleButtonGroup
                        value={idioma}
                        exclusive
                        align="right"
                        onChange={handleIdioma}
                        aria-label="mode"
                      >
                        <ToggleButton value="esp">
                          Español
                        </ToggleButton>
                        <ToggleButton value="port">
                          Português
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                  </Grid>
                </Grid>
              }
            />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Typography color="textPrimary" gutterBottom variant="h6">
                    {dataIdioma.location + ' *'}
                  </Typography>
                  <Autocomplete
                    id="combo-box-region"
                    onChange={handleChangeLocation}
                    options={localidades}
                    getOptionLabel={(option) => option.localidad}
                    isOptionEqualToValue={(option, value) => option.localidad === value.localidad}
                    fullWidth
                    renderInput={(params) => 
                      <TextField 
                        required
                        error={errorLocalidad}
                        label={dataIdioma.location}
                        {...params} 
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography color="textPrimary" gutterBottom variant="h6">
                    {dataIdioma.empresa + ' *'}
                  </Typography>
                  <Autocomplete
                    id="combo-box-empresas"
                    value={empresa}
                    onChange={(event, value) => setEmpresa(value)}
                    options={Empresas}
                    getOptionLabel={(option) => option.nombre}
                    fullWidth
                    renderInput={(params) => 
                      <TextField 
                        required
                        error={errorEmpresa}
                        label={dataIdioma.empresa}
                        {...params} 
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography color="textPrimary" gutterBottom variant="h6">
                    {dataIdioma.name + ' *'}
                  </Typography>
                  <TextField
                    error={errorNome}
                    required
                    id={dataIdioma.name}
                    name={dataIdioma.name}
                    label={dataIdioma.name}
                    fullWidth
                    variant="outlined"
                    inputRef={nomeRef}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography color="textPrimary" gutterBottom variant="h6">
                    {dataIdioma.surname + ' *'}
                  </Typography>
                  <TextField
                    error={errorSobreNome}
                    required
                    id={dataIdioma.surname}
                    name={dataIdioma.surname}
                    label={dataIdioma.surname}
                    fullWidth
                    variant="outlined"
                    inputRef={sobreNomeRef}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography color="textPrimary" gutterBottom variant="h6">
                    {dataIdioma.position + ' *'}
                  </Typography>
                  <TextField
                    error={errorCargo}
                    required
                    id={dataIdioma.position}
                    name={dataIdioma.position}
                    label={dataIdioma.position}
                    fullWidth
                    variant="outlined"
                    inputRef={cargoRef}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid container spacing={3}>
                    <Grid item xs={4} sm={4}>
                      <Typography color="textPrimary" gutterBottom variant="h6">
                        {dataIdioma.codigo}
                      </Typography>
                      <TextField
                        id={dataIdioma.codigo}
                        name={dataIdioma.codigo}
                        label={dataIdioma.codigo}
                        fullWidth
                        variant="outlined"
                        inputRef={codigoRef}
                      />
                    </Grid>
                    <Grid item xs={8} sm={8}>
                      <Typography color="textPrimary" gutterBottom variant="h6">
                        {dataIdioma.phone}
                      </Typography>
                      <TextField
                        id={dataIdioma.phone}
                        name={dataIdioma.phone}
                        label={dataIdioma.phone}
                        fullWidth
                        variant="outlined"
                        inputRef={celularRef}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardContent>
              <Button
                size="large"
                color="primary"
                variant="contained"
                fullWidth
                onClick={getAssinatura}
              >
                Visualizar
              </Button>
            </CardContent>
            <Divider />
            { visualizar && <CardContent ref={copyBoxRef}> {assinatura} </CardContent> }
            <Divider />
            {visualizar &&
              <>
              <TextField
                color="primary"
                sx={{input: {textAlign: "center"}}}
                focused 
                id="Ajuda"
                name="Ajuda"
                fullWidth
                variant="filled"
                value={dataIdioma.help}
                inputProps={
                  { 
                    readOnly: true, 
                    style: {fontSize: 18}
                  }
                }
              />
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <Button
                    size="large"
                    color="primary"
                    variant="text"
                    fullWidth
                    onClick={handleCopiarAssinatura}
                  >
                    {dataIdioma.copy}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    size="large"
                    color="primary"
                    variant="text"
                    fullWidth
                    onClick={event => window.open('https://outlook.office.com/mail/options/mail/messageContent/RoamingSignatureOptions', '_blank', 'noopener,noreferrer')}
                  >
                    {dataIdioma.confirm}
                  </Button>
                </Grid>
              </Grid>
              </>
            }
          </Card>
        </Container>
      </Box>
    </React.Fragment>
  );
}



const MainContent = () => {
  /**
   * useMsal is a hook that returns the PublicClientApplication instance.
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
   */
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  /**
   * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
   * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
   * only render their children if a user is authenticated or unauthenticated, respectively. For more, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
   */
  return (
      <div className="App">
          <AuthenticatedTemplate>
            <Pages />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <h5 className="card-title">Faça o login.</h5>
          </UnauthenticatedTemplate>
      </div>
  );
};

/**
* msal-react is built on the React context API and all parts of your app that require authentication must be
* wrapped in the MsalProvider component. You will first need to initialize an instance of PublicClientApplication
* then pass this to MsalProvider as a prop. All components underneath MsalProvider will have access to the
* PublicClientApplication instance via context as well as all hooks and components provided by msal-react. For more, visit:
* https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
*/
const App = ({ instance }) => {
  return (
      <MsalProvider instance={instance}>
          <PageLayout>
              <MainContent />
          </PageLayout>
      </MsalProvider>
  );
};

export default App;
